/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-header[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #eff0f6;justify-content:space-between;z-index:2;position:fixed;top:0;left:0;right:0}.app-header.mat-toolbar-single-row[_ngcontent-%COMP%]{height:70px}"];
export { styles as styles };
